// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import Image from '@tcp/core/src/components/common/atoms/Image';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

export const CustomRankingContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 2px;
`;

export const RatingsWrapper = styled.div`
  position: relative;

  &,
  img {
    width: 50px;
    max-width: 50px;
    height: 9px;
    display: flex;

    @media ${(props) => props.theme.mediaQuery.large} {
      width: 60px;
      max-width: 60px;
      height: 11px;
    }
  }
`;

export const RatingStarOverlay = styled.span`
  position: absolute;
  top: 0;
  overflow: hidden;
  width: calc(${(props) => `(${props.ratings} / 5) * 50px`});
  height: 9px;

  @media ${(props) => props.theme.mediaQuery.large} {
    width: calc(${(props) => `(${props.ratings} / 5) * 60px`});
    height: 11px;
  }
`;

export const RatingStarMain = styled(Image)`
  background-color: ${(props) => props.theme.colorPalette.gray[800]};
`;

export const RatingStarGrey = styled(Image)`
  background-color: ${(props) => props.theme.colorPalette.gray[500]};
`;

export const ReviewsCount = styled(BodyCopy)`
  font-style: normal;
  font-weight: 600;
  font-size: 8px;
  line-height: 11px;
  margin-top: 2px;
  color: ${(props) => props.theme.colorPalette.gray[800]};

  @media ${(props) => props.theme.mediaQuery.large} {
    font-weight: 500;
    font-size: 11px;
    line-height: 15px;
  }
`;
